import { useEffect } from 'react';
import gtmService from '../../../../../utils/gtm';
import { AudienceHubOptions } from '../../../audienceHub/store/features/options';
import { BrandHubOptions } from '../../../brandHub/store/features/options';

export function useSetOptionsToDataLayer(
  options: AudienceHubOptions | BrandHubOptions,
) {
  useEffect(() => {
    gtmService.pushHubOptionsData(options);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);
}
